// extracted by mini-css-extract-plugin
module.exports = {"multiSelectCrumbs":"Uw-z"};